import api from './api';

export interface SchedulingReturn {
  leg_recno: number;
  pronumber: number;
  leg_num: number;
  container: string | null;
  customer: string | null;
  terminal: string | null;
  pickup: string | null;
  return_to: string | null;
  delivery_type: string;
  proposed_date: string | null;
  time_start: string;
  time_end: string;
  status: 'PLANNING' | 'PENDING' | 'RETURNED' | 'FINALIZED';
  comments: string | null;
}

export interface ReturnPlanUpdate {
  proposed_date: string | null;
  time_start: string | null;
  time_end: string | null;
  comments: string | null;
}

const url = '/scheduling/returns';
export const schedulingReturnsService = {
  async list(params: Record<string, string | number | undefined>) {
    return (await api.get<SchedulingReturn[]>(url, { params })).data;
  },
  async update(legRecno: number, body: ReturnPlanUpdate) {
    await api.patch(`${url}/${legRecno}`, body);
  },
  async sendToLC(legRecno: number) {
    await api.post(`${url}/${legRecno}/send-to-lc`);
  },
  async finalize(legRecno: number) {
    await api.post(`${url}/${legRecno}/finalize`);
  },
  async returnToScheduler(legRecno: number, comments: string) {
    await api.post(`${url}/${legRecno}/return-to-scheduler`, { comments });
  },
};
